<template>
	<JBox class="s-rounded-lg s-border s-border-gray-300 s-bg-white">
		<JFlex class="s-cursor-pointer s-p-5 s-justify-between s-items-center" @click="onExpand">
			<JHeadline class="s-w-1/2 s-text-gray-700 s-text-xl s-font-medium">{{ headline }}</JHeadline>
			<CIcon :name="isExpanded ? 'chevron-up' : 'chevron-down'" class="s-w-6 s-fill-current s-text-gray-500" />
		</JFlex>

		<Transition enter-active-class="animated fadeIn faster">
			<JBox class="s-p-5 s-pt-0" v-if="isExpanded">
				<slot></slot>
			</JBox>
		</Transition>
	</JBox>
</template>

<script>
export default {
	props: {
		headline: { type: String, required: true }
	},

	data: () => ({
		isExpanded: false
	}),

	methods: {
		onExpand() {
			this.isExpanded = !this.isExpanded
			this.$emit("onExpand")
		}
	}
}
</script>
